import apolloClient from "@src/utilities/apollo-client"

import { CART_REMOVE_DISCOUNT_CODE } from "@src/operations/api/cart"

import type { RemoveDiscountCodeMutation } from "@src/entities/types/api"

export default async function removeDiscountCode() {
  return apolloClient.mutate<RemoveDiscountCodeMutation>({
    mutation: CART_REMOVE_DISCOUNT_CODE,
  })
}
